import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Events SetFilter] Action',
  ResetFilter: '[Events ResetFilter] Action',
}

const initialEventsState: IEventsState = {
  filter: {
    teamId: '',
    siteId: '',
    showCalendar: true,
  },
}

export interface IEventsState {
  filter?: {
    siteId: string
    teamId: string
    showCalendar: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Events', whitelist: ['filter']},
  (state: IEventsState = initialEventsState, action: ActionWithPayload<IEventsState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialEventsState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
